import { RedirectRoute } from '../Routing/types';
const redirects: RedirectRoute[] = [
  {
    path: '/terms-of-service',
    redirectTo: '/terms-of-service-web',
  },
];

export default redirects;
